import React from 'react';
import './style/Footer.css';

const Footer = () => {
 // const currentYear = new Date().getFullYear();
  return (
    
    <footer >
    
     
    </footer>
  );
};

export default Footer;